import { ReportRunSchedule, UpdateReportRunScheduleInput } from '@/API';
import { GenericService } from '@/service/GenericService.ts';
import log from 'loglevel';
import { ReportScheduleRepository } from '@/repository/ReportScheduleRepository.ts';

export class ReportScheduleService extends GenericService<ReportRunSchedule> {
  protected repository: ReportScheduleRepository;

  constructor(reportScheduleRepository: ReportScheduleRepository) {
    super(reportScheduleRepository);
    this.repository = reportScheduleRepository;
  }

  async save(
    reportRunSchedule:
      | ReportRunSchedule
      | Omit<
          ReportRunSchedule,
          '__typename' | 'id' | 'createdAt' | 'updatedAt' | 'owner'
        >
  ) {
    try {
      return await this.repository.save(reportRunSchedule);
    } catch (error) {
      log.error('Error saving:', error);
      throw error;
    }
  }

  async update(reportRunSchedule: UpdateReportRunScheduleInput) {
    try {
      return await this.repository.update(reportRunSchedule);
    } catch (error) {
      log.error('Error updating:', error);
      throw error;
    }
  }

  async updateSubscription({
    reportId,
    subscribe,
  }: {
    reportId: string;
    subscribe: boolean;
  }) {
    try {
      return await this.repository.updateSubscription({ reportId, subscribe });
    } catch (error) {
      log.error('Error updating subscription:', error);
      throw error;
    }
  }
}
